import {useNavigationBetweenPartnerListsContext} from '../../../../../../ContextProvider/Navigation/BetweenPartnerLists';
import FoundPartners from './FoundPartners';
import SavedPartners from './SavedPartners';
import MyPartners from './MyPartners';


export default function TabbedResults({className}) {

  const {
    isFoundPartnersActive,
    isSavedPartnersActive
  } = useNavigationBetweenPartnerListsContext();

  if (isFoundPartnersActive()) {
    return <FoundPartners className={className}/>
  }
  else if(isSavedPartnersActive()) {
    return <SavedPartners className={className}/>
  }
  else {
    return <MyPartners className={className}/>
  }
}
